import { cobraConstants } from '../cobra/cobra-constants.js';

export function formatRate(rate) {
  if (!rate.rateBands || rate.rateBands.length === 0) return 'None';
  if (rate.rateBands.length > 1) return 'Multiple';

  let total = rate.rateBands[0].total;
  if (parseFloat(total)) 
    return (formatters.money(total, 4).slice(-2) == '00') ? formatters.money(total, 2) : formatters.money(total, 4);
  return total;
}

export function getStartDateFromDateRange(dateRange) {
  return dateRange ? new Date(dateRange.split(" - ", 1)[0]) : null;
}

export function getEndDateFromDateRange(dateRange) {
  return (dateRange && dateRange.split(" - ")[1] != 'Open') ? new Date(dateRange.split(" - ")[1]) : null;
}

export function getLatestDateRangeFromRates(allRates) {
  if (allRates.length === 0) return null;
  let dateRanges = [...new Set(allRates.map(r => r.dateRange))];
  if (dateRanges.length === 0) return null;

  dateRanges = dateRanges.map(r => ({
    id: r, name: r, startDate: moment(getStartDateFromDateRange(r)), endDate: (getEndDateFromDateRange(r) ? moment(getEndDateFromDateRange(r)) : null)
  }));
  dateRanges.sort((a, b) => b.startDate.isAfter(a.startDate) ? 1 : -1);
  return dateRanges[0].id;
}

export function getDateRangeTextForValidationMessages(dateRangeSet, coverageLevels) {
  let hasMultipleDateRanges = [...new Set(coverageLevels.flatMap(cl => cl.editedRates).map(r => r.dateRange))].length > 1;
  if (!hasMultipleDateRanges) return '';

  let dateRanges = [...dateRangeSet];
  dateRanges.sort((a, b) => moment(b.startDate).isAfter(moment(a.startDate)) ? 1 : -1);

  return ('(Date Range' + (dateRanges.length > 1 ? 's: ' : ': ')) 
    + (hasMultipleDateRanges ? dateRanges.map(r => r.dateRange).join(', ') : '') 
    + ')';
}

export function getCoverageLevelTemplate(planId, dateRange, params) {
  if (params && params.rateBandType) 
    params = { ...getParamsForBandedCoverageLevel(params.rateBandType), ...params };

  return {
    coverageLevelId: null,
    name: params ? params.name : '',
    planId: planId,
    coversEmployee: params ? params.coversEmployee : true,
    explanation: null,
    inUse: false,
    personTypes: !(params && params.personTypes) ? [] : params.personTypes.map(pt => ({
      coverageLevelPersonTypeId: null,
      personType: pt.personType,
      min: pt.min,
      max: pt.max
    })),
    rates: [],
    editedRates: [getRateTemplate(dateRange, params ? params.rateBands : null)],
  }
}

export function getRateTemplate(dateRange, rateBands, rateBandType) {
  return {
    rateId: null,
    startDate: getStartDateFromDateRange(dateRange),
    endDate: getEndDateFromDateRange(dateRange),
    rateBands: rateBands ? rateBands : (
      rateBandType ? getBandedRateBandsTemplate(rateBandType) : [{ 
        total: null,
        age: null,
        gender: null,
        numberOfChildren: null,
        demographicTarget: null
      }]
    ),
    dateRange: dateRange
  };
}

export function sortCoverageLevels(coverageLevels) {
  if (!coverageLevels || coverageLevels.length === 0) return [];

  let orderMap = Object.fromEntries(cobraConstants.STANDARD_COVERAGE_LEVELS.map((cl, index) => [cl.type, index]));
  let nonStandardIndex = Object.keys(orderMap).length;
  coverageLevels.sort((a,b) => {
    let indexA = orderMap[a.name] != undefined ? orderMap[a.name] : nonStandardIndex;
    let indexB = orderMap[b.name] != undefined ? orderMap[b.name] : nonStandardIndex;
    return (indexA != indexB) ? (indexA - indexB) : a.name.localeCompare(b.name);
  });

  return coverageLevels;
}

export function getParamsForBandedCoverageLevel(rateBandType) {
  let params = { rateBands: getBandedRateBandsTemplate(rateBandType) };

  if (!rateBandType.usesCoverageLevels) {
    params = {
      ...params,
      name: "Default",
      coversEmployee: true,
      personTypes: [{ personType: 1, min: 0, max: 1 }]
    };
    
    if (rateBandType.demographicDescriptors.some(d => d.target == cobraConstants.DEMOGRAPHIC_TARGETS.Children.id))
      params.personTypes.push({ personType: 2, min: 0, max: 100 });
  }

  return params;
}

export function getBandedRateBandsTemplate(rateBandType) {
  if (!rateBandType.demographicDescriptors) return [];

  let rateBands = [];

  rateBandType.demographicDescriptors.forEach(d => {
    rateBands.push({ total: null, demographicTarget: d.target, age: null, gender: null, numberOfChildren: null });
  });

  if (rateBandType.demographicDescriptors.some(d => d.demographicType == cobraConstants.DEMOGRAPHIC_TYPES.Gender.id)) {
    let genderDemographicTarget = rateBandType.demographicDescriptors.find(d => d.demographicType == cobraConstants.DEMOGRAPHIC_TYPES.Gender.id).target;
    rateBands = rateBands.filter(rb => rb.demographicTarget != genderDemographicTarget);
    
    Object.values(cobraConstants.RATE_BAND_GENDER).map(gender => gender.id).forEach(genderId => {
      rateBands.push({ gender: genderId, total: null, age: null, demographicTarget: genderDemographicTarget });
    });
  }

  return rateBands;
}


// WEBPACK FOOTER //
// ./src/newCobra/cobra-coverage-level-helpers.js